import { 
    SET_LOADING,
    SET_PROFILE_CATEGORY_LIST,
} from "../../actions/profileCategory/types";

const INITIAL_STATE = {
    loading: false,
    profileCategoryList: [],
}

const ProfileCategoryReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case SET_PROFILE_CATEGORY_LIST: {
            return {
                ...state,
                profileCategoryList : action.payload
            }
        }
        case SET_LOADING: {
            return {
                ...state,
                loading: action.payload
            }
        }
        default: {
            return state;
        }
    }
}

export default ProfileCategoryReducer;